import axios from 'axios';

class BaseApiService {
    constructor(moduleURL) {
        this.server = axios.create({
            baseURL: this.buildBaseURL(moduleURL),
            timeout: 100000,
            headers: {
                common: {
                    'Content-Type': 'application/json',
                },
            },
        });
    }

    buildBaseURL(moduleURL) {
        const serverURL = process.env.VUE_APP_SERVER_URL;
        const connector = serverURL[serverURL.length - 1] === '/' ? '' : '/';
        const fixedModuleURL = moduleURL[0] === '/' ? moduleURL.slice(1) : moduleURL;

        return `${serverURL}${connector}${fixedModuleURL}`;
    }

    setAuthorization(token) {
        this.server.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    async request({ method, url, data, params }) {
        try {
            const response = await this.server.request({
                method,
                url,
                data,
                params,
            });

            return this.handleResponse(response);
        } catch (err) {

            if (url === '/login') {
                return JSON.parse(JSON.stringify(err));
            }

            return this.handleError(err);
        }
    }

    handleResponse(response) {
        return response.data;
    }

    async handleError(err) {
        throw err;
    }
}

export default BaseApiService;
